export const initializeGainsight = (n, t, a, e) => {
  // TODO: update public URL and ID to the final ones
  const gainsightUrl =
    process.env.REACT_APP_GAINSIGHT_URL ||
    "https://web-sdk.aptrinsic.com/api/aptrinsic.js";
  const gainsightProductId =
    process.env.REACT_APP_GAINSIGHT_ID || "AP-QAFSYBOJBEWJ-2-4";

  //   gainsight script provided on official documentation
  //   see https://support.gainsight.com/PX/API_for_Developers/01About/Work_with_Gainsight_PX_Web_SDK

  (function (n, t, a, e) {
    var i = "aptrinsic";
    (n[i] =
      n[i] ||
      function () {
        (n[i].q = n[i].q || []).push(arguments);
      }),
      (n[i].p = e);
    var r = t.createElement("script");
    (r.async = !0), (r.src = a + "?a=" + e);
    var c = t.getElementsByTagName("script")[0];
    c.parentNode.insertBefore(r, c);
  })(window, document, gainsightUrl, gainsightProductId);
};
